import React from "react";
import Body from "EventLight/Agenda/Manage/View/Body";

const Layout = ({ handlers }) => <Body handlers={handlers} />;

export default Layout;
